export interface CardInput {
  series: string;
  title: string;
  techLabel?: string;
  spec: string;
  topic?: string;
  description: string;
  images: File[];
}

export interface CardResult {
  pageIndex: number;
  zone: "left" | "right";
  wasNewPage: boolean;
}

export const ALLOWED_SERIES = [
  "#未來生活解密",
  "#解密科技故事",
  "#歷史上的今天",
  "#科技快充站",
  "#解密科技Everyday",
  "#科技報報",
] as const;

export type Series = (typeof ALLOWED_SERIES)[number];

export const SERIES_LABELS: Record<Series, string> = {
  "#未來生活解密": "未來生活解密",
  "#解密科技故事": "解密科技故事",
  "#歷史上的今天": "歷史上的今天",
  "#科技快充站": "科技快充站",
  "#解密科技Everyday": "解密科技Everyday",
  "#科技報報": "科技報報",
};
